export default __webpack_public_path__ + "static/media/ic-playlist-link.85fbd617.svg";